<div class="l-wrapper">
  <!-- <app-header></app-header>
  <div class="l-main-management">
    <div class="l-main-management__img">
      <img
        src="./../../../../assets/img/management-main.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/management-sp-main.png"
        alt=""
        class="c-sp"
      />
    </div> -->
  <div class="l-main-management__content1">
    <h2 translate class="l-main-management__content1__title">
      {{ "management.content1.title" }}
    </h2>
    <div class="l-main-management__content1__description">
      <p translate>
        {{ "management.content1.description.1" }}
      </p>
      <p translate>
        {{ "management.content1.description.2" }}
      </p>
      <p translate>
        {{ "management.content1.description.3" }}
      </p>
    </div>
  </div>

  <div class="l-main-management__content2">
    <h2 translate class="l-main-management__content2__title">
      {{ "management.content2.title" }}
    </h2>
  </div>

  <div class="l-main-management__content2__description">
    <div class="l-main-management__content2__description__list">
      <div>
        <img src="./../../../../assets/img/management-content2-1.png" alt="" />
      </div>
      <p translate class="c-first-content">
        {{ "management.content2.description.1" }}
      </p>
    </div>
    <div class="l-main-management__content2__description__list">
      <div>
        <img src="./../../../../assets/img/management-content2-2.png" alt="" />
      </div>
      <p translate class="c-first-content">
        {{ "management.content2.description.2" }}
      </p>
    </div>
    <div class="l-main-management__content2__description__list">
      <div>
        <img src="./../../../../assets/img/management-content2-3.png" alt="" />
      </div>
      <div class="c-first-content">
        <p translate>{{ "management.content2.description.last.1" }}</p>
        <p translate>{{ "management.content2.description.last.2" }}</p>
        <p translate>{{ "management.content2.description.last.3" }}</p>
      </div>
    </div>
  </div>
  <!-- </div>
  <app-footer></app-footer>
</div> -->
</div>
